import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DataService from "@shared/services/DataService";
import { FormField } from "@shared/modules/utils";
import { I18n } from "@shared/modules/utils/LangUtil";
import EventService from "@shared/services/EventService";
import { InputAdornment } from "@mui/material";
import Keyboard from "react-simple-keyboard";

export const OTP_LENGTH = 6;
export const OTP_PREFIX_LENGTH = 4;
export const TOTAL_OTP_LENGTH = OTP_LENGTH + OTP_PREFIX_LENGTH;
const OTP_STATUSES = {
    "SMS":{"label":"your Mobile",'lbl':"motp"},
    "EMAIL":{"label":"your Email",'lbl':"eotp"},
    "WHATSAPP":{"label":"your WHATSAPP",'lbl':"wotp"},
    "EMAIL":{"label":"your Email",'lbl':"eotp"},
    "WOTP":{"label":"your WHATSAPP",'lbl':"wotp"},
    "Notp":{"label":"your Notp",'lbl':"otp"}
};
export const SUCCESS_STATUSES = ["VERIFY_SUCCESS", "SUCCESS", "USER_UPDATE_SUCCESS"];

class DotpPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            motpSent: false,
            eotpSent: false,
            disableSubmit: true,
            contactType: null,
            otpInputVal: "",
            mOtpPrefixVal: "",
            eotpInputVal:"",
            eOtpPrefixVal:"",
            focusOtpField:"motp"
        };
    }

    componentDidMount() {
        this.init();
        EventService.publish("keyboard.hide");
    }

    init() {
        // this.otpInput.val(`${this.props.otpPrefix}-`);
        this.mOtpPrefix = this.props.otpPrefix;
        this.eOtpPrefix = this.props.eOtpPrefix;
        this.setState({
            motpSent: true,
            eotpSent: true,
            mOtpPrefixVal: `${this.props.otpPrefix}-`,
            eOtpPrefixVal: `${this.props.eOtpPrefix}-`
        });
    }

    reset() {
        this.otpInput.clearError();
        // this.otpInput.val("");
        this.setState({
            otpInputVal: ``,
            eotpInputVal:``
        });
    }

    handleMOTPInput = newValue => {
        if (!this.mOtpPrefix) {
        } else {
            // this.otpInput.val(`${this.otpPrefix}-`);
            this.otpInput.clearError()
            this.setState({
                mOtpPrefixVal: `${this.props.otpPrefix}-`,
            });
            if (newValue.length <= 6) {
                if (newValue.length === OTP_LENGTH && this.state.eotpInputVal.length === OTP_LENGTH) {
                    this.setState({ disableSubmit: false });
                } else {
                    this.setState({ disableSubmit: true });
                }
                // this.otpInput.val(newValue);
                this.setState({
                    otpInputVal: newValue
                });
            }
        }
    };

    handleEOTPInput = newValue => {
        if (!this.eOtpPrefix) {
        } else {
            // this.otpInput.val(`${this.otpPrefix}-`);
            this.otpInput.clearError()
            this.setState({
                eOtpPrefixVal: `${this.props.eOtpPrefix}-`,
            });
            if (newValue.length <= 6) {
                if (newValue.length === OTP_LENGTH && this.state.otpInputVal.length === OTP_LENGTH) {
                    this.setState({ disableSubmit: false });
                } else {
                    this.setState({ disableSubmit: true });
                }
                // this.otpInput.val(newValue);
                this.setState({
                    eotpInputVal: newValue
                });
            }
        }
    };

    handleKeyboardInput = newVal => {
        if (newVal) {
            let currValue = this.state.focusOtpField=="motp" ? this.state.otpInputVal:this.state.eotpInputVal;
            let finalValue = currValue;
            if (newVal === "{backspace}") {
                finalValue = currValue.slice(0, -1);
            } else {
                finalValue = currValue + newVal;
            }
            if(this.state.focusOtpField=="motp"){
                this.handleMOTPInput(finalValue);
            }
            else{
                this.handleEOTPInput(finalValue);
            }
        }
    };

    resendOTP = () => {
        let postMethodPromise;
        let { contactType } = this.state;
        contactType = contactType ? contactType : this.props.config.contactType;
        var reqBase64 = btoa(JSON.stringify({ contactType: "SMS_EMAIL" }));
        this.setState({ contactType: contactType });
        if (this.props.postForm) {
            postMethodPromise = DataService.post(this.props.api, this.props.reqObj, {
                ...this.props.config,
                params: {
                    ...(this.props.config && this.props.config.params ? this.props.config.params : {}),
                    "x-app-authd-params": reqBase64
                },
                contactType: "SMS_EMAIL",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                otpSuccessCallback: this.props.otpSuccessCallback
            });
        } else {
            postMethodPromise = DataService.post(
                this.props.api,
                {
                    ...(this.props.reqObj || {})
                },
                {
                    ...this.props.config,
                    params: {
                        ...(this.props.config && this.props.config.params ? this.props.config.params : {}),
                        "x-app-authd-params": reqBase64
                    },
                    contactType: "SMS_EMAIL",
                    otpSuccessCallback: this.props.otpSuccessCallback
                }
            );
        }
        postMethodPromise.then(resp => {
            if (this.props.otpSentStatusKeys.indexOf(resp.statusKey) !== -1) {
                // this.otpInput.val(`${resp.meta.mOtpPrefix}-`);
                this.mOtpPrefix = resp.meta.mOtpPrefix 
                this.eOtpPrefix = resp.meta.eOtpPrefix 
                this.setState({
                    motpSent: true,
                    eotpSent: true,
                    mOtpPrefixVal: `${this.props.otpPrefix}-`,
                    eOtpPrefixVal: `${this.props.eOtpPrefix}-`,
                    otpInputVal: "",
                    eotpInputVal:"",
                    disableSubmit: true
                });
            } else if (resp.statusKey != "CUSTOMER_MOBILE_EMPTY") {
                this.otpInput.setError(resp.errorMsg);
            }
        });
    };

    onClickNext = () => {
        this.setState({ loading: true });
        console.log("this.otpInput.isValid()",this.otpInput.isValid());
        if ([!this.mOtpPrefix || this.otpInput.isValid(),!this.eOtpPrefix || this.eotpInput.isValid()].indexOf(false) !== -1){
            this.setState({ loading: false })
            return;
        } 

        // let mOtp = this.otpInput.val().split("-")[1];
        let mOtp = this.state.otpInputVal;
        let eOtp = this.state.eotpInputVal;
        let wOtp = ""
        // if(this.props?.config?.contactType=="SMS" || this.props?.config?.contactType == "EMAIL" || this.props?.config?.contactType == "WHATSAPP" || this.props?.config?.contactType == "Notp"){
        //     mOtp = this.props?.config?.contactType=="SMS" || this.props?.config?.contactType=="Notp" ?this.state.otpInputVal:" ";
        //     eOtp = this.props?.config?.contactType=="EMAIL" ?this.state.otpInputVal:" ";
        //     wOtp = this.props?.config?.contactType=="WHATSAPP" ?this.state.otpInputVal:" ";
        // }
        if (this.props.saveCallback)
            this.props
                .saveCallback({
                    id: this.props.meta.id,
                    mOtp,
                    eOtp,
                    wOtp,
                    otpSuccessCallback: this.props.otpSuccessCallback,
                    config: this.props.config,
                    contactType: "SMS_EMAIL"
                })
                .then(resp => {
                    this.setState({ loading: false });
                    if (SUCCESS_STATUSES.indexOf(resp.statusKey) === -1) {
                        if (resp.messageKey === "INVALID_OTP") {
                            this.otpInput.setError(resp.errorMsg || resp.message);
                        }
                    }
                });
    };

    onClickCancel = () => {
        EventService.publish("globalModal.hide");
    };

    render() {
        let conOtp=false
        let conType=""
        if(this.props?.config?.contactType=="SMS" || this.props?.config?.contactType == "EMAIL" || this.props?.config?.contactType == "WHATSAPP" || this.props?.config?.contactType == "Notp"){
            conOtp=true
            conType=this.props?.config?.contactType
        }

        return (
            <div className="verfy-number">
                <span className="dialog__h1">{I18n("g.lbl.verifyotp")}</span>
                <br />
                <br />
                <span className="dialog__h2">
                    Please enter the OTP code you have <br />
                    received on your Mobile and Email
                </span>
                <div className="md-otp modal-sm">
                    <FormField
                        controlled={true}
                        type={"text"}
                        containerClass={"sm otp-popup-prefix"}
                        ref={ref => (this.mOtpPrefix = ref)}
                        value={this.state.mOtpPrefixVal}
                        disabled={true}
                    />
                    <FormField
                        controlled={true}
                        containerClass="blurFocus"
                        type={"otp"}
                        label={I18n("g.lbl.motp")}
                        inputValidations={["validOTP"]}
                        ref={ref => (this.otpInput = ref)}
                        value={this.state.otpInputVal}
                        onChange={this.handleOTPInput}
                        disabled={!this.state.motpSent}
                        length={6}
                        sizeRange={[OTP_LENGTH, OTP_LENGTH]}
                        id="otp"
                        showKeyboard={false}
                        autoFocus={true}
                        onFocus={()=>this.setState({focusOtpField:"motp"})}
                    />
                </div>
                <div className="md-otp modal-sm">
                    <FormField
                        controlled={true}
                        type={"text"}
                        containerClass={"sm otp-popup-prefix"}
                        ref={ref => (this.eOtpPrefix = ref)}
                        value={this.state.eOtpPrefixVal}
                        disabled={true}
                    />
                    <FormField
                        controlled={true}
                        containerClass="blurFocus"
                        type={"otp"}
                        label={I18n("g.lbl.eotp")}
                        inputValidations={["validOTP"]}
                        ref={ref => (this.eotpInput = ref)}
                        value={this.state.eotpInputVal}
                        onChange={this.handleOTPInput}
                        disabled={!this.state.eotpSent}
                        length={6}
                        sizeRange={[OTP_LENGTH, OTP_LENGTH]}
                        id="otp"
                        showKeyboard={false}
                        autoFocus={false}
                        onFocus={()=>this.setState({focusOtpField:"eotp"})}
                    />
                </div>
                <div
                    className={`otp-button-text modal-sm ${this.state.loading ? "disabled" : ""}`}
                    style={{ fontSize: "27px" }}
                    {...(this.state.loading ? {} : { onClick: this.resendOTP })}
                >
                    Resend OTP
                    <img className="search-adornment" src={require(`@app/styles/img/right-arrow.svg`)} alt="logo" />
                </div>
                <br />
                <div style={{ height: "400px", width: "660px" }}>
                    <Keyboard
                        className="simple-keyboard"
                        layout={{
                            default: ["1 2 3", "4 5 6", "7 8 9", " 0 {backspace}"]
                        }}
                        layoutName={"default"}
                        theme={"hg-theme-default hg-layout-Modal Modal-theme"}
                        mergeDisplay={true}
                        buttonTheme={[
                            {
                                class: "hg-red",
                                buttons: "OK"
                            },
                            {
                                class: "hg-highlight",
                                buttons: "1 2 3 4 5 6 7 8 9 0   {backspace}"
                            },
                            {
                                class: "hg-round3",
                                buttons: "3"
                            },
                            {
                                class: "hg-round1",
                                buttons: "1"
                            },
                            {
                                class: "hg-round9",
                                buttons: " "
                            },
                            {
                                class: "hg-round7",
                                buttons: "{backspace}"
                            }
                        ]}
                        display={{
                            "{backspace}": "⌫"
                        }}
                        onKeyPress={button => this.handleKeyboardInput(button)}
                    />
                </div>
                <br />
                <div className="spacer-div2" style={{ width: "660px" }}>
                    <button
                        className={`primary-btn btn ${this.state.loading ? "disabled" : ""}`}
                        style={{ width: "300px", height: "123px", margin: 0 }}
                        onClick={this.onClickCancel}
                        {...(this.state.loading ? { disabled: true } : {})}
                    >
                        {I18n("g.action.cancel")}
                    </button>
                    <button
                        className={`success-btn btn ${
                            this.state.disableSubmit || this.state.loading ? "disabled" : ""
                        }`}
                        style={{ width: "300px", height: "123px", margin: 0 }}
                        onClick={this.onClickNext}
                        {...(this.state.disableSubmit || this.state.loading ? { disabled: true } : {})}
                    >
                        {I18n("g.action.next")}
                    </button>
                </div>
            </div>
        );
    }
}

export default withRouter(DotpPopup);
